export class DocumentModel {

    public id: number;
    public typeId: number;
    public status: string;
    public imagePreviewUrl: string;
    public imageOriginalUrl: string;
    public date: string;
    public expiryDate: string;
    public uploadedBy: string;

    constructor(obj?: any) {
        this.id                 = obj && obj.id                 || null;
        this.typeId             = obj && obj.typeId             || null;
        this.status             = obj && obj.status             || '';
        this.imagePreviewUrl    = obj && obj.imagePreviewUrl    || '';
        this.imageOriginalUrl   = obj && obj.imageOriginalUrl   || '';
        this.date               = obj && obj.date               || '';
        this.expiryDate         = obj && obj.expiryDate         || '';
        this.uploadedBy         = obj && obj.uploadedBy         || '';
    }
}



// WEBPACK FOOTER //
// ./src/app/models/document.model.ts